import React from 'react';
import circle from "./../../../../Images/circle.png"

import Typical from 'react-typical'
import HoverImage from "react-hover-image";

import img from '../../../../Images/circle-cropped (2).png'

import Fade from 'react-reveal/Fade';


const MainSection = () => {


    return (
        <div className="container justify-content-center align-items-center d-flex">
            <div className="row m-auto mt-5" style={{ width: '1250px' }}>
                <div className="col-md-6 mt-5">
                    <Fade left>
                        <HoverImage className="img-fluid" style={{ width: '300px', height: '300px', backgroundColor: '#d9dad7', borderRadius: "50%" }} src={circle} hoverSrc={img} />
                    </Fade>
                </div>
                <div className="col-md-6  mt-5">
                    <Fade right>

                        <p>Looking for a Developer !</p>
                        <h1 style={{ color: '#008000', fontWeight: '700', fontSize: '50px' }}>I am Raj Dev Ullash</h1>
                        <h1 className="mt-3" style={{ color: 'black', fontWeight: '700', fontSize: '30px' }}><Typical
                            steps={['Web Designer', 3000, 'Web Developer', 3000, 'Frontend Developer', 3000, 'API Developer', 3000]}
                            loop={Infinity}
                            wrapper="p"
                        /></h1>
                        <p className="mt-3" style={{ color: '#8492AE' }}>Obviously I'm a Front End Developer. Experienced with all stages of the development cycle for dynamic web projects.</p>
                        <a href="https://drive.google.com/uc?export=download&id=1NYN3mcMTZdlzM-gwPlI_L6hfkg1OddZ6"><button className="btn btn-outline-success rounded-3 mt-3">Download Resume</button></a>
                    </Fade>
                </div>
            </div>
        </div>
    );
};

export default MainSection;